import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetDispatch } from "../../../store/store";
import { NumericFormat } from "react-number-format";
import { setCauseAreaAmount } from "../../../store/actions";
import { usePlausible } from "next-plausible";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { thousandize } from "../../../../../../../util/formatting";
import { CauseArea } from "../../../types/CauseArea";
import { CauseAreaDisplayConfig } from "../../../types/WidgetProps";
import { CauseAreaRollout } from "../../shared/CauseAreaRollout/CauseAreaRollout";
import styles from "../AmountPane.module.scss";
import { getCauseAreaIconById } from "../../shared/CauseAreaIcon/CauseAreaIcon";
interface OperationsCauseAreaFormProps {
  causeArea: CauseArea;
  suggestedSums: Array<{
    amount: number;
    subtext?: string;
  }>;
  causeAreaAmounts: Record<number, number>;
  causeAreaDisplayConfig: CauseAreaDisplayConfig;
}
export const OperationsCauseAreaForm: React.FC<OperationsCauseAreaFormProps> = t0 => {
  const $ = _c(42);
  const {
    causeArea,
    suggestedSums,
    causeAreaAmounts,
    causeAreaDisplayConfig
  } = t0;
  const dispatch = useWidgetDispatch();
  const plausible = usePlausible();
  let t1;
  if ($[0] !== causeArea.id) {
    t1 = getCauseAreaIconById(causeArea.id);
    $[0] = causeArea.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = causeArea.widgetDisplayName || causeArea.name;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={styles.causeAreaTitle}>{t1}{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== causeArea.id || $[6] !== causeAreaDisplayConfig) {
    t4 = getCauseAreaContext(causeArea.id, causeAreaDisplayConfig);
    $[5] = causeArea.id;
    $[6] = causeAreaDisplayConfig;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className={styles.causeAreaContext}>{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== causeArea.id || $[14] !== causeAreaAmounts || $[15] !== dispatch || $[16] !== plausible || $[17] !== suggestedSums) {
    let t8;
    if ($[19] !== causeArea.id || $[20] !== causeAreaAmounts || $[21] !== dispatch || $[22] !== plausible) {
      t8 = suggested => <div key={suggested.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={causeAreaAmounts[causeArea.id] === suggested.amount} onClick={() => {
          plausible("SelectSuggestedSum", {
            props: {
              sum: suggested.amount
            }
          });
          dispatch(setCauseAreaAmount(causeArea.id, suggested.amount));
        }} noMinWidth={true}>{`${suggested.amount ? thousandize(suggested.amount) : "-"} kr`}</EffektButton>{suggested.subtext && <i>{suggested.subtext}</i>}</div>;
      $[19] = causeArea.id;
      $[20] = causeAreaAmounts;
      $[21] = dispatch;
      $[22] = plausible;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t7 = suggestedSums.map(t8);
    $[13] = causeArea.id;
    $[14] = causeAreaAmounts;
    $[15] = dispatch;
    $[16] = plausible;
    $[17] = suggestedSums;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <div className={styles.sumButtonsWrapper}>{t7}</div>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const t9 = causeAreaAmounts[causeArea.id] > 0 ? causeAreaAmounts[causeArea.id] : "";
  let t10;
  if ($[26] !== causeArea.id || $[27] !== dispatch) {
    t10 = (values, sourceInfo) => {
      if (sourceInfo.source !== "event") {
        return;
      }
      const v = values.floatValue === undefined ? 0 : values.floatValue;
      dispatch(setCauseAreaAmount(causeArea.id, v));
    };
    $[26] = causeArea.id;
    $[27] = dispatch;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <div className={styles.sumWrapper}><span><NumericFormat name="sum-operations" type="tel" placeholder="0" thousandSeparator=" " value={t9} autoComplete="off" data-cy="donation-sum-input-operations" onValueChange={t10} allowNegative={false} decimalScale={0} /></span></div>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t8) {
    t12 = <div><div className={styles.totalSumWrapper}>{t8}{t11}</div></div>;
    $[32] = t11;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== causeArea.id || $[36] !== causeAreaDisplayConfig) {
    t13 = <CauseAreaRollout causeAreaId={causeArea.id} config={causeAreaDisplayConfig} />;
    $[35] = causeArea.id;
    $[36] = causeAreaDisplayConfig;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t12 || $[39] !== t13 || $[40] !== t6) {
    t14 = <div className={styles.formWrapper}>{t6}{t12}{t13}</div>;
    $[38] = t12;
    $[39] = t13;
    $[40] = t6;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};
const getCauseAreaContext = (id: number, config?: CauseAreaDisplayConfig) => {
  const context = config?.cause_area_contexts?.find(c => c.cause_area_id === id);
  return context?.context_text || null;
};